import { Container, Size } from 'pixi.js';
import ConfigurationRenderer from '../ConfigurationRenderer';

abstract class DrawableObject {
	id = crypto.randomUUID();

	protected renderer: ConfigurationRenderer;
	container = new Container();
	dimensions: Size = { width: 0, height: 0 };
	scaledDimensions: Size = { width: 0, height: 0 };

	constructor(renderer: ConfigurationRenderer) {
		this.renderer = renderer;
	}

	abstract draw(): void;

	destroy() {
		this.container.destroy({ children: true });
	}
}

export default DrawableObject;
